"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NavBarMenuButton = void 0;
var _react = _interopRequireWildcard(require("react"));
var _react2 = require("@floating-ui/react");
var _classnames = _interopRequireDefault(require("classnames"));
var _useResizeObserver = require("design_system/hooks/useResizeObserver");
var _usePrevious = require("design_system/hooks/usePrevious");
var _Icon = require("design_system/Icon");
var _Text = require("design_system/Text");
var _MenuButton = require("design_system/Menu/MenuButton");
var _MenuContext = require("design_system/Menu/MenuContext");
var _NavBarContext = require("./NavBarContext");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const THEME = {
  position: "flex items-center justify-between",
  text: "text-gray-171731 whitespace-no-wrap",
  focus: "s768:focus:outline-none s768:focus:underline",
  hover: "s768:hover:underline",
  p: "py-12 s768:p-0",
  m: "s768:mr-32",
  w: "w-full s768:w-auto",
  rounded: "rounded-8"
};
const NavBarMenuButton = /*#__PURE__*/(0, _react.forwardRef)((_ref, ref) => {
  let {
    className,
    children,
    expandOnOpen,
    ...props
  } = _ref;
  const thisRef = (0, _react.useRef)(null);
  const thisRefProp = (0, _react2.useMergeRefs)([thisRef, ref]);
  const {
    open: navOpen
  } = (0, _NavBarContext.useNavBarContext)();
  const {
    open: menuOpen
  } = (0, _MenuContext.useMenuContext)();
  const [width] = (0, _useResizeObserver.useResizeObserver)();
  const prevWidth = (0, _usePrevious.usePrevious)(width);
  (0, _react.useEffect)(() => {
    // Close any menu that is open when the screen width passes breakpoint
    const isNarrowScreen = width > 0 && width <= _useResizeObserver.BREAKPOINTS.s768;
    const prevIsNarrowScreen = prevWidth === 0 || prevWidth === undefined ? null : prevWidth < _useResizeObserver.BREAKPOINTS.s768;
    if (menuOpen && prevIsNarrowScreen !== null && prevIsNarrowScreen !== isNarrowScreen) {
      var _thisRef$current;
      (_thisRef$current = thisRef.current) === null || _thisRef$current === void 0 ? void 0 : _thisRef$current.click();
    }
  }, [width]);
  (0, _react.useEffect)(() => {
    // Open menus with expandOnOpen prop when nav is opened
    if (expandOnOpen && width <= _useResizeObserver.BREAKPOINTS.s768 && !menuOpen && navOpen) {
      var _thisRef$current2;
      (_thisRef$current2 = thisRef.current) === null || _thisRef$current2 === void 0 ? void 0 : _thisRef$current2.click();
    }
  }, [navOpen]);
  const getTrailingIcon = (0, _react.useCallback)(() => {
    if (width > _useResizeObserver.BREAKPOINTS.s768) {
      return /*#__PURE__*/_react.default.createElement(_Icon.ChevronDown, {
        size: 16
      });
    }
    return menuOpen ? /*#__PURE__*/_react.default.createElement(_Icon.ChevronUp, null) : /*#__PURE__*/_react.default.createElement(_Icon.ChevronDown, null);
  }, [width, menuOpen]);
  return /*#__PURE__*/_react.default.createElement(_MenuButton.MenuButton, _extends({
    role: "menuitem",
    ref: thisRefProp,
    text: THEME.text,
    focus: THEME.focus,
    hover: THEME.hover,
    p: THEME.p,
    m: THEME.m,
    w: THEME.w,
    rounded: THEME.rounded,
    className: (0, _classnames.default)(className, THEME.position)
  }, props), /*#__PURE__*/_react.default.createElement(_Text.Text, {
    variant: "body-md",
    className: "mr-4"
  }, children), getTrailingIcon());
});
exports.NavBarMenuButton = NavBarMenuButton;
NavBarMenuButton.displayName = "NavBar.MenuButton";